import { calculateNumbersWidth } from 'fabscale-app/utilities/utils/chart';

export default function calculateValuesWidthHelper(values: number[]) {
  return calculateNumbersWidth(values);
}
